import React, { memo } from "react";
import { Box, Button, Alert, AlertTitle, Typography } from "@mui/material";
import { MyLocation } from "@mui/icons-material";

/**
 * Virtual Bore Tool control panel content
 */
const VirtualBoreControl = memo(({ isEnabled = false, onToggle }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Alert severity="info" sx={{ mb: 1 }}>
        <AlertTitle>How to Use</AlertTitle>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Click the button below to enable the tool, then click anywhere on the
          map to analyze geological data at that location.
        </Typography>
        <Typography variant="body2">
          The tool will display a detailed geological cross-section showing
          subsurface layers, depths, and formations.
        </Typography>
      </Alert>

      <Button
        variant={isEnabled ? "contained" : "outlined"}
        color={isEnabled ? "secondary" : "primary"}
        onClick={onToggle}
        startIcon={<MyLocation />}
        fullWidth
      >
        {isEnabled ? "Tool Active - Click Map" : "Enable Virtual Bore Tool"}
      </Button>

      {isEnabled && (
        <Alert severity="success" sx={{ mt: 1 }}>
          <Typography variant="body2">
            Tool is active! Click anywhere on the map to analyze geological
            data.
          </Typography>
        </Alert>
      )}
    </Box>
  );
});

VirtualBoreControl.displayName = "VirtualBoreControl";

export default VirtualBoreControl;
